import { useEffect } from "react";
import { internetConnectionChange, internetConnectionInitAction } from "./internetConnectionActions";
import { useDispatch } from "react-redux";

function InternetConnectionProvider() {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(internetConnectionInitAction());
        const subscribe = () => dispatch(internetConnectionChange(navigator.onLine));
        window.addEventListener("online", subscribe);
        window.addEventListener("offline", subscribe);
        return () => {
            window.removeEventListener("online", subscribe);
            window.removeEventListener("offline", subscribe);
        }; 
    }, [dispatch]);

    return null;
}

export default InternetConnectionProvider;
